import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignPlansAPI from '../../api/campaignPlans';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCampaignPlans(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getCampaignPlans({ commit }) {
    commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignPlansAPI.get();
      commit(types.SET_CAMPAIGN_PLANS, response.data);
    } catch (error) {
      // Handle error
    } finally {
      commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCampaignPlan({ commit }, campaignPlanObj) {
    commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignPlansAPI.create(campaignPlanObj);
      commit(types.ADD_CAMPAIGN_PLAN, response.data);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isCreating: false });
    }
  },
  delete: async ({ commit }, campaignPlanId) => {
    commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isDeleting: true });
    try {
      await CampaignPlansAPI.delete(campaignPlanId);
      commit(types.DELETE_CAMPAIGN_PLAN, campaignPlanId);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CAMPAIGN_PLAN_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_PLAN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CAMPAIGN_PLAN]: MutationHelpers.create,
  [types.SET_CAMPAIGN_PLANS]: MutationHelpers.set,
  [types.DELETE_CAMPAIGN_PLAN]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};

